import { Moment } from 'moment';

export default class SlaV2MediaFile {
  entityId!: number;
  entityType = '';
  subEntityId: number | null = null;
  subEntityType: string | null = null;
  id!: number;
  mediaFileType!: number;
  isLocked = false;
  isWaranty = false;
  createdOn!: Moment;
  createdById: number | null = null;
  description: string | null = null;
  note: string | null = null;
  originalContent = '';
  originalSize: number | null = null;
  mediumContent = '';
  mediumSize!: number;
  smallContent = '';
  smallSize!: number;
  extraSmallContent = '';
  extraSmallSize!: number;
}